module.exports = __webpack_public_path__ + "img/guapai.bc1499f.png";